export const Endpoints = {
  ADD_PAGE: '/add',
  EDIT_PAGE: '/edit',
  FACEBOOK_PAGE: 'https://www.facebook.com/Artistic-Home-109736017273044/'
};
